module.exports = __webpack_public_path__ + "static/img/xingspa.3caf64b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/xingspa.png
// module id = rYHv
// module chunks = 1